import axiosInstance from '../lib/axiosInstance';

export const getAirports = async () => {
  return axiosInstance.get('/trips/airports');
};

export const getTripsSchedule = async () => {
  return axiosInstance.get('/trips/schedule');
};
